import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "defaultChecked"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { forwardRef } from "react";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconCheck = function IconCheck(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(-17.529 -22.087)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.674,33.177,27.1,43.116l18.862-20",
        fill: "none",
        stroke: "#eb7d3c",
        strokeWidth: "3"
      })
    })
  }));
};

IconCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29.523",
  height: "23.278",
  viewBox: "0 0 29.523 23.278"
};
var MetaSelectorField = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      defaultChecked = props.defaultChecked,
      _props = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx("div", {
    className: styles.metaSelectorField,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.metaSelector,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        id: "checkbox-".concat(name),
        name: name,
        type: "checkbox",
        defaultChecked: defaultChecked
      }, _props)), /*#__PURE__*/_jsx("label", {
        htmlFor: "checkbox-".concat(name),
        className: styles.label,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(IconCheck, {})
        })
      })]
    })
  });
});
MetaSelectorField.displayName = "MetaSelectorField";
export default MetaSelectorField;